export const NYC = [
    "https://images.unsplash.com/photo-1477882244523-716124bf91a1?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
    "https://images.unsplash.com/photo-1485871981521-5b1fd3805eee?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
    "https://images.unsplash.com/photo-1665416738654-98ebf6aab981?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
    "https://images.unsplash.com/photo-1518355077561-4af7abce973d?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
    "https://images.unsplash.com/photo-1599854171059-d91f0fee45cd?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
    "https://images.unsplash.com/photo-1722206335508-f370f8ba10d4?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
];

export const NYC_LABELS = [
    "Brooklyn Bridge, 2am",
    "Empire State, golden hour",
    "The Verrazzano",
    "Downtown from above",
    "Skyline from DUMBO",
    "Narrows ferry",
];

export const STREET = [
    "https://images.unsplash.com/photo-1768321611135-6294fc2296a5?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
    "https://images.unsplash.com/photo-1556806597-b6b969b2d9be?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
    "https://images.unsplash.com/photo-1546594718-9a0997a99189?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
    "https://images.unsplash.com/photo-1703725164412-f0c2882c7582?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
];

export const COMICS = [
    "https://images.unsplash.com/photo-1628426912206-d88e22da5c76?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
    "https://images.unsplash.com/photo-1639634252346-0a27c7d168dc?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
    "https://images.unsplash.com/photo-1588497859490-85d1c17db96d?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
    "https://images.unsplash.com/photo-1618519764620-7403abdbdfe9?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
];

export const MERCH = [
    "https://images.unsplash.com/photo-1696086152504-4843b2106ab4?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
    "https://images.unsplash.com/photo-1696086152586-09a0855dbc9c?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
    "https://images.unsplash.com/photo-1696086152513-c74dc1d4b135?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
];
